import { Link } from 'react-router-dom'
import { FaHome } from 'react-icons/fa'
import Button from '@material-ui/core/Button'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import janus_logo from '../../media/white_janus_logo.png'

const styles = makeStyles({
  root: {
      display: "flex",
      flexWrap: "wrap"
  },
  margin: {
      margin: '5px'
  },
  buttonTheme: {
      color: '#ffffff',
      borderColor: '#104b72',
      borderWidth: 'thin',
      backgroundColor: '#4589b6',
      '&:hover': {
        backgroundColor: '#176ca4',
      },
  }
});

export const PublicLayout = ({ children }) => {
  const classes = styles();
  return (
    <div className='public-layout'>

      <div className='topbar'>
        <Button
          className={classNames(classes.margin, classes.buttonTheme)}
          style={{ float: 'left', fontSize: '30px' }}
          variant="outlined"
          size='small'
          component={Link}
          to="/"
        >
          <FaHome style={{ color: 'white' }} />
        </Button>

        <img src={janus_logo} alt="" style={{ paddingTop: '5px', width: '300', height: '44px', margin: 'auto', marginLeft: '1em' }} />


        <Button
          className={classNames(classes.margin, classes.buttonTheme)}
          style={{ float: 'right', fontSize: '16px'}}
          variant="outlined"
          component={Link} 
          to='/login'
        >
          Sign in
        </Button>
      </div>

      <main>
        {children}
      </main>
    </div>
  )
}